import { ApiUtility } from "../Utilities/ApiUtility.axios";

export enum SubmissionHoldType {
    HardStop,
    WarningOnly
}

export const SubmissionHoldTypeList = [
    { label: "All Type", value: null },
    { label: "Error", value: SubmissionHoldType.HardStop },
    { label: "Warning", value: SubmissionHoldType.WarningOnly }
];

export enum ApplicationPracticeSubmissionType {
    Unknown = 0,

    AR_CH = 1,
    // AR_HMRC = 2,
    CT = 3,
    SA100 = 4,

    SA800 = 5,
    SA900 = 6,
    CIS = 7,

    EPS = 8,
    FPS = 9,
    P11D = 10,

    CS = 11,
    CS_Additional = 12,
    VAT = 13,
}

export const ApplicationPracticeSubmissionTypeList = [
    { label: "AR (CH)", value: ApplicationPracticeSubmissionType.AR_CH },
    // { label: "AR HMRC", value: ApplicationPracticeSubmissionType.AR_HMRC },
    { label: "CT 600", value: ApplicationPracticeSubmissionType.CT },
    { label: "SA 100", value: ApplicationPracticeSubmissionType.SA100 },

    { label: "SA 800", value: ApplicationPracticeSubmissionType.SA800 },
    { label: "SA 900", value: ApplicationPracticeSubmissionType.SA900 },
    { label: "CIS", value: ApplicationPracticeSubmissionType.CIS },

    { label: "EPS", value: ApplicationPracticeSubmissionType.EPS },
    { label: "FPS", value: ApplicationPracticeSubmissionType.FPS },
    { label: "P11D", value: ApplicationPracticeSubmissionType.P11D },

    { label: "CS", value: ApplicationPracticeSubmissionType.CS },
    { label: "CS Additional", value: ApplicationPracticeSubmissionType.CS_Additional },
    { label: "VAT", value: ApplicationPracticeSubmissionType.VAT }
];

class PracticeSubmissionHoldService {
    route = `/Api/ApplicationPracticeSubmissionHold`;

    get = (search?: string, start = 0, length = 15, sortCol?: string, sortDir?: string, status: number = 0, fromDate?: string, toDate?: string, errorType?: SubmissionHoldType, practiceId?: number[], filingTypes?: ApplicationPracticeSubmissionType[]) =>
        ApiUtility.get(this.route, { search, start, length, sortCol, sortDir, status, fromDate, toDate, errorType, filingTypes, practiceId });

    save = (practiceId: any, payload: any) => ApiUtility.post(`${this.route}/create`, payload);

    update = (id: string, payload: any) => ApiUtility.post(`${this.route}/update/${id}`, payload);

}

export default new PracticeSubmissionHoldService();
